import { motion } from "framer-motion";

export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="flex items-center justify-center min-h-[500px] p-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="max-w-md w-full text-center"
      >
        {/* Icon Container */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{
            delay: 0.2,
            type: "spring",
            stiffness: 200,
            damping: 15,
          }}
          style={{ backgroundColor: "rgba(0, 0, 0, 0.07)" }}
          className="w-24 h-24 mx-auto mb-6 rounded-full flex items-center justify-center shadow-sm"
        >
          {Icon && <Icon className="w-12 h-12 text-muted-foreground" />}
        </motion.div>

        {/* Content */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          <h2 className="mb-3">{title}</h2>
          <p className="text-muted-foreground mb-8 leading-relaxed">
            {description}
          </p>

          {/* Action Button */}
          {action && (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
            >
              {action}
            </motion.div>
          )}
        </motion.div>

        {/* Decorative Elements */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="mt-12 flex items-center justify-center gap-2"
        >
          <div className="w-2 h-2 rounded-full bg-muted-foreground/20"></div>
          <div className="w-2 h-2 rounded-full bg-muted-foreground/30"></div>
          <div className="w-2 h-2 rounded-full bg-muted-foreground/20"></div>
        </motion.div>
      </motion.div>
    </div>
  );
}
